export const GET_JOBTYPE_REQUEST = 'GET_JOBTYPE_REQUEST';
export const GET_JOBTYPE_SUCCESS = 'GET_JOBTYPE_SUCCESS';
export const GET_JOBTYPE_FAIL = 'GET_JOBTYPE_FAIL';

export const CREATE_JOBTYPE_REQUEST = 'CREATE_JOBTYPE_REQUEST';
export const CREATE_JOBTYPE_SUCCESS = 'CREATE_JOBTYPE_SUCCESS';
export const CREATE_JOBTYPE_FAIL = 'CREATE_JOBTYPE_FAIL';
export const CREATE_JOBTYPE_RESET = 'CREATE_JOBTYPE_RESET';

export const EDIT_JOBTYPE_REQUEST = 'EDIT_JOBTYPE_REQUEST';
export const EDIT_JOBTYPE_SUCCESS = 'EDIT_JOBTYPE_SUCCESS';
export const EDIT_JOBTYPE_FAIL = 'EDIT_JOBTYPE_FAIL';
export const EDIT_JOBTYPE_RESET = 'EDIT_JOBTYPE_RESET';

export const DELETE_JOBTYPE_REQUEST = 'DELETE_JOBTYPE_REQUEST';
export const DELETE_JOBTYPE_SUCCESS = 'DELETE_JOBTYPE_SUCCESS';
export const DELETE_JOBTYPE_FAIL = 'DELETE_JOBTYPE_FAIL';
export const DELETE_JOBTYPE_RESET = 'DELETE_JOBTYPE_RESET';

export const START_JOB_REQUEST = 'START_JOB_REQUEST';
export const START_JOB_SUCCESS = 'START_JOB_SUCCESS';
export const START_JOB_FAIL = 'START_JOB_FAIL';
export const START_JOB_RESET = 'START_JOB_RESET';

export const GET_JOBS_REQUEST = 'GET_JOBS_REQUEST';
export const GET_JOBS_SUCCESS = 'GET_JOBS_SUCCESS';
export const GET_JOBS_FAIL = 'GET_JOBS_FAIL';

export const GET_JOB_REQUEST = 'GET_JOB_REQUEST';
export const GET_JOB_SUCCESS = 'GET_JOB_SUCCESS';
export const GET_JOB_FAIL = 'GET_JOB_FAIL';